export const ENS_SUFFIX = '.eth'
